// extracted by mini-css-extract-plugin
export default {"loadingSpinner":"loadingScreen_loadingSpinner__Rd-vT","spinner":"loadingScreen_spinner__fgiWg","spin":"loadingScreen_spin__ZuDUI","message":"loadingScreen_message__v6BWX"};